import { PermisoMantisEnum } from "@shared/enums/mantis/permisos-mantis.enum";
import { PerfilMantisEnum } from "@shared/enums/mantis/perfil-mantis.enum";

export const PerfilPermisosMap: Record<PerfilMantisEnum, PermisoMantisEnum[]> = {
    [PerfilMantisEnum.INFORMADOR]: [
        PermisoMantisEnum.SOLO_LECTURA
    ],
    [PerfilMantisEnum.DESARROLLADOR]: [
        PermisoMantisEnum.REPORTAR,
        PermisoMantisEnum.ASIGNAR_USUARIO,
        PermisoMantisEnum.EDITAR_RPTA_FINAL,
        PermisoMantisEnum.GESTIONAR_NOTAS,
        PermisoMantisEnum.MODIFICAR_RELACIONES,
        PermisoMantisEnum.ESTADO_RESUELTO,
        PermisoMantisEnum.EDITAR
    ],
    [PerfilMantisEnum.ASOFONDOS]: [
        PermisoMantisEnum.REPORTAR,
        PermisoMantisEnum.ASIGNAR_USUARIO,
        PermisoMantisEnum.EDITAR_RPTA_FINAL,
        PermisoMantisEnum.GESTIONAR_NOTAS,
        PermisoMantisEnum.EDITAR,
        PermisoMantisEnum.MODIFICAR_RELACIONES,
        PermisoMantisEnum.ESTADO_RESUELTO,
        PermisoMantisEnum.ESTADO_CERRADO,
        PermisoMantisEnum.ESTADO_ASIGNADO
    ],
};
